import { r as registerInstance, h } from './index-5faac9d7.js';
import { b as productCtas, ae as CAASContentOverviewSlotName } from './currency-7be6806c.js';
import { r as requestRangeSelectorConfig } from './helper-6fbc871e.js';
import { u as updateProductCtasSelectorSettings } from './product-selector-utils-94175aab.js';
import { T as TAB_NAMES } from './constants-74678075.js';
import { a as getFilteredBreadcrumbs } from './utils-5c7c3926.js';
import './index-e29b327a.js';
import './lodash-bd96d09c.js';
import './_commonjsHelpers-11ca3be1.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';
import './analytics-b6a65ffa.js';
import './number-57a50dcb.js';
import './helpers-e12aa36b.js';
import './constants-7d3b1dc0.js';

const ProductAppRange = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productCtasState = this.productCtas;
    this.productSelector = null;
    this.requestRangeSelectorConfigCreator = () => requestRangeSelectorConfig(this.host, this.rangeId);
    this.host = undefined;
    this.endpoint = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.rangeId = undefined;
    this.showBreadcrumbs = undefined;
    this.showDocuments = undefined;
    this.productCtas = productCtas;
    this.showBuyOnline = undefined;
    this.siteType = undefined;
    this.mainInfo = undefined;
    this.tabs = undefined;
    this.recentlyViewedProducts = undefined;
    this.isTabsInitialized = false;
    this.isLoading = false;
    this.documentsTabEnabled = {
      [TAB_NAMES.Documents]: false,
      [TAB_NAMES.Software]: false,
    };
    this.documentListing = undefined;
  }
  productCtasDidChange(newProductCtas) {
    this.selectorExtraOptions = updateProductCtasSelectorSettings(this.productSelector, this.productCtas.buttons);
    this.productCtasState = Object.assign({}, newProductCtas);
  }
  get customBreadcrumbs() {
    var _a;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs((_a = this.mainInfo) === null || _a === void 0 ? void 0 : _a.breadcrumbs);
  }
  getRichText(content) {
    const { richText } = content;
    const richTextResponse = richText || content.MainContent[0].richText;
    return richTextResponse === null || richTextResponse === void 0 ? void 0 : richTextResponse.map((item) => item.replace(/<p>|&nbsp;|&#160;|<\/p>/g, '').trim());
  }
  render() {
    const { image, name, description, masterRangeName, longDescription, rangePartofLabel, } = this.mainInfo;
    return (h("se-container", { display: "block", style: {
        'background-color': '#FFF',
      } }, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: false, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs" })), h("pes-range-main", { host: this.host, endpoint: this.endpoint, rangePartofLabel: rangePartofLabel, commercialStatus: this.mainInfo.commercialStatus, description: description, image: image, longDescription: longDescription, masterRangeName: masterRangeName, name: name, brandLogo: this.mainInfo.brandLogo, id: this.mainInfo.id, localeCode: `${this.countryCode.toUpperCase()}/${this.languageCode}`, rangeCtas: this.mainInfo.rangeCtas, requestRangeSelectorConfig: this.requestRangeSelectorConfigCreator, rangeType: this.mainInfo.rangeType }), this.tabs.tabs && (h("pes-range-tabs", { tabs: this.tabs.tabs, appProductsLabel: this.mainInfo.appProductsLabel, commonFiltersFilterBy: this.mainInfo.commonFiltersFilterBy, facetButtonResetAllLabel: this.mainInfo.facetButtonResetAllLabel, facetButtonViewLessFilters: this.mainInfo.facetButtonViewLessFilters, facetButtonViewMoreFilters: this.mainInfo.facetButtonViewMoreFilters, nextLabel: this.mainInfo.nextLabel, pageLabel: this.tabs.pageLabel, noResultsClearLink: this.mainInfo.noResultsClearLink, noResultsHeader: this.mainInfo.noResultsHeader, noResultsMessage: this.mainInfo.noResultsMessage, numberProductsOfAllProductsLabel: this.mainInfo.numberProductsOfAllProductsLabel, previousLabel: this.mainInfo.previousLabel, rangeProductLabel: this.mainInfo.rangeProductLabel, rangeProductsFiltersLabel: this.mainInfo.rangeProductsFiltersLabel, viewLessLabel: this.mainInfo.viewLessLabel, viewMoreLabel: this.mainInfo.viewMoreLabel, viewProductsLabel: this.mainInfo.viewProductsLabel, rangePresentationLabel: this.mainInfo.rangePresentationLabel, loadMoreLabel: this.tabs.loadMoreLabel, loadPreviousLabel: this.tabs.loadPreviousLabel, backLabel: this.mainInfo.backLabel, localeCode: `/${this.countryCode}/${this.languageCode}`, rangeReference: this.mainInfo.rangeReference, host: this.host, endpoint: this.endpoint, rangeSoftwareAndFirmwareLabel: this.mainInfo.rangeSoftwareAndFirmwareLabel, descriptionBigger: this.mainInfo.descriptionBigger, id: this.mainInfo.id, name: name, navigationState: this.mainInfo.navigationState, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, seoURl: this.seoUrl, productCtas: this.productCtasState, isPBS: true, nodes: this.mainInfo.nodes, documentListing: this.documentListing }, h("slot", { slot: CAASContentOverviewSlotName, name: CAASContentOverviewSlotName }))), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { isBackgroundGrey: true, class: "pes-app-range__section" }))));
  }
  static get watchers() { return {
    "productCtas": ["productCtasDidChange"]
  }; }
};

export { ProductAppRange as pes_app_range };
